import gql from "graphql-tag";

export const MY_HR_GET_COMPANIES_ADMIN_LIST = gql`
  query adminListCompanies(
    $searchField: String
    $searchText: String
    $sort: String
    $page: Int
    $pageSize: Int
    $companies: [String]
  ) {
    adminListCompanies(
      searchField: $searchField
      searchText: $searchText
      sort: $sort
      page: $page
      pageSize: $pageSize
      companies: $companies
    ) {
      availableList {
        _id
        code
        name
      }
      selectedList {
        _id
        code
        name
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;
